import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideClientHydration, withEventReplay, withNoIncrementalHydration } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { PortfolioDataService } from '@app/common/services/portfolio-data.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const portfolioDataService = inject(PortfolioDataService);
      return portfolioDataService.init();
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch()),
    provideRouter(routes),
    provideClientHydration(withEventReplay(), withNoIncrementalHydration())
  ]
};
